var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "draggerElement",
      staticClass: "chat-panel-fit-dragger",
      class: { dragging: _setup.isDragging },
      style: { transform: `translateX(${-_setup.movement}px)` },
      on: {
        pointerdown: _setup.startDragging,
        pointermove: _setup.handlePointerMove,
        dblclick: _setup.resetCustomWidth,
      },
    },
    [
      _c("div", { staticClass: "chat-panel-fit-dragger-bar" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "chat-panel-fit-dragger-preview-area",
          style: { width: `${_setup.previewWidth}px` },
        },
        [
          _c(
            "div",
            { staticClass: "chat-panel-fit-dragger-preview-area-background" },
            [
              _vm._v(
                "\n      " + _vm._s(_setup.previewWidth.toFixed(1)) + "px\n    "
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }